export { default } from '../components/pages/Story';
